import React from 'react';
import { getRunDateString } from '../utils/dateUtils';

const RunsList = ({ runs, onSelectRun }) => (
  <div className="runs-list">
    <h2>Bisherige Läufe</h2>
    <div className="runs-grid">
      {runs
        .slice()
        .sort((a, b) => b.timestamp.localeCompare(a.timestamp))
        .map(run => (
          <div key={run.id} className="run-card">
            <p className="runner-name">{run.name}</p>
            <p className="date">
              {(() => {
                const dateString = getRunDateString(run.date);
                return dateString
                  ? new Date(dateString).toLocaleDateString('de-DE', {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })
                  : 'Unbekanntes Datum';
              })()}
            </p>
            <p className="kilometers">{run.kilometers} km</p>
            {run.imageUrl && (
              <img
                src={run.imageUrl}
                alt="Laufnachweis"
                loading="lazy"
                width="200"
                height="200"
                onError={(e) => (e.target.style.display = 'none')}
                onClick={() => onSelectRun(run)}
                style={{ cursor: 'pointer' }}
              />
            )}
          </div>
        ))}
    </div>
  </div>
);

export default RunsList;
